module.exports = __webpack_public_path__ + "static/media/chair.b83430b9.png";